import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { t } from 'core/i18n/i18n';
import { DevicesFilterFields } from './devices-filters';

export const DEVICE_STATUSES = {
    SYSTEM_READY: 'SYSTEM_READY',
    SYSTEM_NOT_READY: 'SYSTEM_NOT_READY',
    SYSTEM_WAITING_OPERATOR_ACTION: 'SYSTEM_WAITING_OPERATOR_ACTION',
    PARTIAL_LOCK: 'PARTIAL_LOCK',
    LOCK: 'LOCK',
};

export const DEVICE_ORIGIN = {
    APP: 'APP',
    EDGE: 'EDGE',
};

export const DEVICE_SECURITY_TYPES = {
    OPEN: 'OPEN',
    WPA_PSK: 'WPA_PSK',
    EAP: 'EAP',
    UNKNOWN: 'UNKNOWN',
} as const;

export const defaultFilters: {
    active: UserCustomFilter<DevicesFilterFields>;
    inactive: UserCustomFilter<DevicesFilterFields>;
} = {
    active: {
        name: t('modules.devices.pods.devices-list.table.title.active'),
        fields: {
            active: true,
            deviceType: [],
        },
        sorting: {},
    },
    inactive: {
        name: t('modules.devices.pods.devices-list.table.title.inactive'),
        fields: {
            active: false,
            deviceType: [],
        },
        sorting: {},
    },
};
export const DeviceCommandPlacementsMapping: Record<string, string> = {
    ROW_OPTIONS: 'row-options',
    SIDESHEET_HEADER: 'sidesheet-header',
    BULK_ACTIONS: 'bulk-actions',
};

export const NO_EAP_SETTINGS = 'NO_EAP_SETTINGS';
export const MAX_NUMBER_OF_OPTIONS_WITHOUT_SEARCH = 9;
